import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Checkbox({ isChecked }: Props) {
  return (
    <div
      className={classNames(styles.checkbox, { [styles.checked]: isChecked })}
    />
  );
}

export { Checkbox };
